import apiClient from '../../../../../services/apiClient';

/**
 * Get detailed info (name, birth date, etc.) for children currently active
 * in a group as of a given date.
 */
export const getGroupChildrenInfo = async (kgId, groupId, dateTo = new Date().toISOString()) => {
  // type=only_child — не тягнемо зарезервовані (ще не зараховані) місця,
  // вони не повинні потрапляти у вибір для переведення.
  const url = `kindergartens/${kgId}/children/main_info?groups=${groupId}&date_to=${dateTo}&period=day&type=only_child`;

  try {
    const response = await apiClient.get(url);
    return response;
  } catch (error) {
    throw new Error(`Error getting group children info: ${error}`);
  }
};

/** Search kindergartens by name/number (for the target-kindergarten autocomplete). */
export const searchKindergartens = async (search, limit = 20) => {
  const url = search
    ? `kindergartens/list?search=${encodeURIComponent(search)}&limit=${limit}`
    : `kindergartens/list?limit=${limit}`;

  try {
    const response = await apiClient.get(url);
    return response;
  } catch (error) {
    throw new Error(`Error searching kindergartens: ${error}`);
  }
};

/** Get a kindergarten's full record (used to read its group list). */
export const getKindergarten = async (kgId) => {
  try {
    const response = await apiClient.get(`kindergartens/${kgId}`);
    return response;
  } catch (error) {
    throw new Error(`Error getting kindergarten: ${error}`);
  }
};

/**
 * Bulk, permanent transfer of children from a group in the current
 * kindergarten to a group in another kindergarten. Admin-only on the backend.
 * Requires the backend route (see README):
 * POST /v1/kindergartens/:id/groups/transfer_to_kindergarten/:target_kg_id/children
 *   ?group_number=...&target_group_number=...
 */
export const transferChildrenToAnotherKindergarten = async (
  kgId,
  sourceGroupNumber,
  targetKindergartenId,
  targetGroupNumber,
  payload
) => {
  // Номери груп (group_number/target_group_number) навмисно в
  // query-параметрах, а не в шляху URL: номер групи іноді містить крапки,
  // дужки чи пробіли (напр. "05-(2025-2026)", "10 2026-2027"), і шлях із
  // такими символами (особливо ".." як підрядок) блокується
  // security-фільтром на рівні інфраструктури ще до Node.js.
  const url = `kindergartens/${kgId}/groups/transfer_to_kindergarten/${targetKindergartenId}/children`
    + `?group_number=${encodeURIComponent(sourceGroupNumber)}`
    + `&target_group_number=${encodeURIComponent(targetGroupNumber)}`;

  try {
    const response = await apiClient.post(url, payload);
    return response;
  } catch (error) {
    throw new Error(`Error transferring children to another kindergarten: ${error}`);
  }
};